module.exports = __webpack_public_path__ + "static/media/bilisi.0186f3d8.webp";